(function () {
  "use strict";

  usersResource.$inject = ['$resource', 'errorHandler'];
  angular
    .module('trainerWebApp.resources')
    .factory('usersResource', usersResource);

  function usersResource($resource, errorHandler) {
    var UsersResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/user/:userId');
    var CustomFieldResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/user-custom-field');
    var BulkUserResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/user/:type');
    var AddUserResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/add-user-setup/:page');
    var AddUserForCourseResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/add-user-setup/:page/:courseId');
    var ManageUsersResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/manage-users-setup');
    var SearchResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/manage-users-search-setup');
    var XlsUserImport = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/xls-user-import-setup');
    var BulkImport = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/user-import');
    var UserGroupResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/user/:userId/group/:type');

    // User management page
    UsersResource.prototype.getUsers = function getAllUsers(resultCb, errorCb) {
      return BulkUserResource.query({}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.getUserCustomFields = function getUserCustomFields(resultCb, errorCb) {
      return CustomFieldResource.get(resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.importUsers = function importUsers(dto, resultCb, errorCb) {
      return BulkImport.save(dto, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.importNewUsers = function importNewUsers(dto, resultCb, errorCb) {
      dto.mode = 'add';
      return BulkImport.save(dto, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.getUserInfo = function getUserInfo(userId, resultCb, errorCb) {
      return UsersResource.get({userId: userId}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.getMultipleUserInfo = function getMultipleUserInfo(params, resultCb, errorCb) {
      params = _.defaults(params || {}, {includeCourseAndSeriesInfo: false});
      return BulkUserResource.save({type: 'loadmultiple'}, params, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.archiveUsers = function archiveUsers(userIds, resultCb, errorCb) {
      return BulkUserResource.save({type: 'archive'}, {userIds: userIds}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.reactivateUsers = function reactivateUsers(userIds, resultCb, errorCb) {
      return BulkUserResource.save({type: 'reactivate'}, {userIds: userIds}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.updateUserGroups = function updateUserGroups(params, resultCb, errorCb) {
      return BulkUserResource.save({type: 'group'}, params, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.inviteUsersToCoursesAndSeries = function inviteUsersToCoursesAndSeries(params, resultCb, errorCb) {
      return BulkUserResource.save({type: 'invite'}, params, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.updateCustomField = function updateCustomField(params, resultCb, errorCb) {
      return BulkUserResource.save({type: 'custom-field'}, params, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    // User management page and update profile for managers/trainers.
    UsersResource.prototype.updateUserInfo = function (userId, info, resultCb, errorCb) {
      return UsersResource.save({userId: userId}, info, resultCb || angular.noop, errorCb || errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.getSetupForManageUsers = function getSetupForManageUsers(resultCb, errorCb) {
      return ManageUsersResource.get(resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.getSetupForManageUsersSearch = function getSetupForManageUsersSearch(options, resultCb, errorCb) {
      return SearchResource.save(options, resultCb || angular.noop, errorCb || errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.getAddUserSetupForManage = function getAddUserSetupForAddNewUser(resultCb, errorCb) {
      return AddUserResource.get({page: 'manage'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb))
    };

    UsersResource.prototype.getAddUserSetupForCourseType = function getAddUserSetupForCourseType(resultCb, errorCb) {
      return AddUserResource.get({page: 'course'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb))
    };

    UsersResource.prototype.getAddUserSetupForCourse = function getAddUserSetupForCourse(courseId, resultCb, errorCb) {
      return AddUserForCourseResource.get({page: 'course', courseId: courseId}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb))
    };

    UsersResource.prototype.getXlsUserImportSetup = function getXlsUserImportSetup(resultCb, errorCb) {
      return XlsUserImport.get(resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb))
    };

    UsersResource.prototype.getUsersInCourse = function getUsersInCourse(resultCb, errorCb) {
      return ManageUsersResource.get(resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb))
    };

    UsersResource.prototype.getUserGroupsRestrictions = function getUserGroupsRestrictions(userId, resultCb, errorCb) {
      return UserGroupResource.query({userId: userId, type: "restriction"}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    UsersResource.prototype.updateUserGroupsRestrictions = function updateUserGroupsRestrictions(userId, groupIds, resultCb, errorCb) {
      return UserGroupResource.save({userId: userId, type: "restriction"}, {groupIds: groupIds}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new UsersResource;
  }

})();

